export default __webpack_public_path__ + "static/media/parking-hover.65ff39ee.svg";